import { render, staticRenderFns } from "./Actus.vue?vue&type=template&id=b2c99d3e&"
import script from "./Actus.vue?vue&type=script&lang=js&"
export * from "./Actus.vue?vue&type=script&lang=js&"
import style0 from "./Actus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports